<template>
    <b-container fluid class="animated fadeIn">
        <h1>Cadastro de Procurador</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect
                                                v-model="filtrarPor"
                                                :show-labels="false"
                                                :options="opcoesFiltro"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="filtro"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                        class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Nome:" label-for="nome" class="text-label">
                                            <b-form-input v-model="filtro.nome" type="text" id="nome" maxlength="90" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="CPF:" label-for="cpf" class="text-label">
                                            <b-form-input v-model="filtro.cpf" type="text" id="cpf" maxlength="14" v-mask="'###.###.###-##'" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                                        <b-form-group label="Número OAB:" label-for="numeroOAB" class="text-label">
                                            <the-mask
                                                    id="numeroOAB"
                                                    class="form-control"
                                                        v-model="filtro.numeroOAB"
                                                    :mask="'######'"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="6" md="2" lg="2" xl="2">
                                        <b-form-group
                                            label="UF OAB:"
                                            label-for="ufOAB">
                                            <multiselect
                                                name="ufOAB"
                                                v-model="filtro.ufOAB"
                                                :show-labels="false"
                                                :options="dados.ufs"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                :preserve-search="false"
                                                placeholder="Selecione"
                                                track-by="sigla"
                                                label="sigla"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                                        <b-form-group label="Código SPJ:" label-for="codProcuradorSPJ" class="text-label">
                                            <b-form-input v-model="filtro.codProcuradorSPJ" type="text" id="codProcuradorSPJ" maxlength="12" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Situação:" label-for="situacao" class="text-label">
                                            <b-form-checkbox-group
                                                v-model="filtro.situacao"
                                                :options="dados.situacao">
                                            </b-form-checkbox-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Grupo de Trabalho:" label-for="grupoTrabalho" class="text-label">
                                            <multiselect
                                                name="grupoTrabalho"
                                                v-model="filtro.grupoTrabalho"
                                                :show-labels="false"
                                                :options="dados.grupoTrabalho"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                :preserve-search="false"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="nome"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 8).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Assessor:" label-for="assessores" class="text-label">
                                            <multiselect
                                                name="assessores"
                                                v-model="filtro.assessores"
                                                :show-labels="false"
                                                :options="dados.assessores"
                                                :multiple="true"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                :preserve-search="false"
                                                placeholder="Selecione"
                                                track-by="codUsuario"
                                                label="nomeUsuario"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button variant="primary" class="fonte-branca ml-1" @click="filtrar">
                                <i class="fa fa-search"></i> Pesquisar
                            </b-button>
                            <b-button variant="primary" @click.prevent="incluir" class="fonte-branca ml-1">
                                <i class="fa fa-plus"></i> Incluir
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length !== 1" @click.prevent="alterar">
                                <i class="fa fa-pencil"></i> Alterar
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length !== 1" @click.prevent="exibir">
                                <i class="fa fa-eye"></i> Exibir
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-col xs="12">
                        <div>
                            <b-row class="d-flex justify-content-between">
                                <b-col>
                                    <label class="mt-3">Procuradores - Quantidade: <strong>{{ configTable.rows }}</strong></label>
                                </b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                            <TabelaProcurador
                                :resultado="resultado"
                                :fields="fields"
                                :configTable="configTable"
                                :selecteds="selecteds"
                                @sortingChanged="consultar"
                                @consultar="consultar" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompExibirOcultarColuna from '../components/CompBotaoExibirOcultarColuna'
import CompPaginacao from '../components/CompPaginacao'
import TabelaProcurador from './TabelaProcurador'

export default {
    name: 'ManterProcurador',
    components: {
        CompExibirOcultarColuna,
        CompPaginacao,
        TabelaProcurador
    },
    data() {
        return {
            fields: [
                {
                    key: "selecionar",
                },
            ],
            showColunms: [],
            filtro: {
                nome: null,
                cpf: null,
                numeroOAB: null,
                ufOAB: null,
                codProcuradorSPJ: null,
                situacao: [1],
                grupoTrabalho: null,
                assessores: []
            },
            dados: {
                ufs: [],
                usuarios: [],
                situacao: [
                    { text: 'Ativo', value: 1 },
                    { text: 'Inativo', value: 0 }
                ],
                grupoTrabalho: [],
                assessores: []
            },
            filtrarPor: [ {
                    id: 6,
                    filtro: 'Situação'
                }],
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Nome'
                },
                {
                    id: 2,
                    filtro: 'CPF'
                },
                {
                    id: 3,
                    filtro: 'Número OAB'
                },
                {
                    id: 4,
                    filtro: 'UF OAB'
                },
                {
                    id: 5,
                    filtro: 'Código SPJ'
                },
                {
                    id: 6,
                    filtro: 'Situação'
                },
                {
                    id: 7,
                    filtro: 'Grupo de Trabalho'
                },
                {
                    id: 8,
                    filtro: 'Assessor'
                }
            ],
            configTable: {
                perPage: 100,
                sortField: 'nome',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            resultado: [],
            selecteds: [],
        }
    },
    methods: {
        /**
         * Incluir
         */
        incluir(evt) {
            evt.preventDefault()
            this.$store.commit('setProcurador', null)
            this.$router.push({ path: '/procurador/editar' })
        },

        /**
         * Alterar
         */
        alterar(evt) {
            evt.preventDefault()
            if(this.selecteds[0]) {
                this.$store.commit('setProcurador', this.selecteds[0])
                this.$router.push({ path: '/procurador/editar' })
            }
        },

        /**
         * Exibir
         */
        exibir(evt) {
            evt.preventDefault()
            if(this.selecteds[0]) {
                this.$store.commit('setProcurador', this.selecteds[0])
                this.$router.push({ path: '/procurador/exibir' })
            }
        },

        /**
         * Consultar
         */
        async consultar() {
            this.selecteds = []
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if(this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/procurador/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.resultado = response.data.resultado
                if(this.configTable.perPage !== 'Todos') {
                    this.configTable.rows = response.data.rows
                }
            }).finally(() => {
                this.loadingExit()
            })

        },

        /**
         * Obter filtro
         */     
        obterFiltro() {
            return {
                nome: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.nome : null,
                cpf: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.cpf : null,
                numeroOAB: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.numeroOAB : null,
                ufOAB: (this.filtrarPor.filter(e => e.id == 4).length > 0) ? this.filtro.ufOAB : null,
                codProcuradorSPJ: (this.filtrarPor.filter(e => e.id == 5).length > 0) ? this.filtro.codProcuradorSPJ : null,
                situacoes: (this.filtrarPor.filter(e => e.id == 6).length > 0) ? this.filtro.situacao : null,
                grupoTrabalho: (this.filtrarPor.filter(e => e.id == 7).length > 0) && this.filtro.grupoTrabalho.id ? this.filtro.grupoTrabalho.id : null,
                assessores: (this.filtrarPor.filter(e => e.id == 8).length > 0) && this.filtro.assessores && this.filtro.assessores.length > 0 ? this.filtro.assessores.map(a => a.codUsuario) : null,
            }
        },

        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                nome: null,
                cpf: null,
                numeroOAB: null,
                ufOAB: null,
                codProcuradorSPJ: null,
                situacao: null,
                grupoTrabalho: null,
                assessores: null
            }
            this.filtrarPor = []
            this.filtrar();
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.configTable.rows = 0
            this.configTable.checkedAll = false
            this.resultado = []
            this.selecteds = []
            this.consultar()
        },

        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API
            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })          
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'procurador'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: this.checkClassTable(i),
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if(i == 1 || i == 2 || i == 3 || i == 4 || i == 7 || i == 8)
                return 'text-center justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        },

        /**
         * Listar UFs
         */
        async listarUfs() {
            
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/procurador/listarUfs`, {}, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.ufs = response.data
            })
        },

        /**
         * Listar GrupoTrabalho
         */
         async listarGrupoTrabalho() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/grupotrabalho/listarAtivos`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.grupoTrabalho = response.data
            })
        },

        /**
         * Listar Assessores
         */
         async listarAssessores() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const params = {
                grupoSentinela: 'PGEPROAJU-AGENDAPRAZO-ASSES'
            }

            axios.get(`${urlApi}/v1/usuario`, {
                params: params,
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.assessores = response.data
            })
        },
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultar()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const msgProcurador = this.$store.getters.getMsgProcurador;
        if(msgProcurador) {
            this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [msgProcurador] });
            this.$store.commit("setMsgProcurador", null)
        }

        this.obterConfiguracaoUsuario()
        this.listarUfs()
        this.listarGrupoTrabalho()
        this.listarAssessores()

        this.consultar()

    }
    
}
</script>

<style scoped>

</style>